var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4949 20C12.2316 20 12.012 19.9023 11.836 19.707C11.66 19.5117 11.5718 19.2678 11.5714 18.9753V11.1224H11V10.4883H13.2857V10H16.7143V10.4883H19V11.1224H18.4286V18.9759C18.4286 19.2676 18.3406 19.5113 18.1646 19.707C17.9886 19.9028 17.7688 20.0004 17.5051 20H12.4949ZM13.7474 18.0977H14.3189V12.3906H13.7474V18.0977ZM15.6811 18.0977H16.2526V12.3906H15.6811V18.0977Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.4c41e298bb6916dd472ecde55bf4521a.svg";
export { ForwardRef as ReactComponent };